function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1398_1975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.00016 5.33337C5.18426 5.33337 5.3335 5.18414 5.3335 5.00004C5.3335 4.81595 5.18426 4.66671 5.00016 4.66671C4.81607 4.66671 4.66683 4.81595 4.66683 5.00004C4.66683 5.18414 4.81607 5.33337 5.00016 5.33337Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.39083 1.72404C8.14084 1.47397 7.80176 1.33345 7.44816 1.33337H2.66683C2.31321 1.33337 1.97407 1.47385 1.72402 1.7239C1.47397 1.97395 1.3335 2.31309 1.3335 2.66671V7.44804C1.33357 7.80163 1.4741 8.14072 1.72416 8.39071L7.52683 14.1934C7.82984 14.4945 8.23966 14.6635 8.66683 14.6635C9.094 14.6635 9.50382 14.4945 9.80683 14.1934L14.1935 9.80671C14.4946 9.5037 14.6636 9.09388 14.6636 8.66671C14.6636 8.23954 14.4946 7.82972 14.1935 7.52671L8.39083 1.72404Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.00016 5.33337C5.18426 5.33337 5.3335 5.18414 5.3335 5.00004C5.3335 4.81595 5.18426 4.66671 5.00016 4.66671C4.81607 4.66671 4.66683 4.81595 4.66683 5.00004C4.66683 5.18414 4.81607 5.33337 5.00016 5.33337Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1398_1975"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.d9eff444.svg";
export { ForwardRef as ReactComponent };